import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      title: "Architectural Design",
      description: "Complete architectural solutions from concept to construction, including residential and commercial projects.",
      features: ["3D Modeling", "Construction Documents", "Project Management", "Sustainable Design"]
    },
    {
      title: "Interior Design",
      description: "Transform your spaces with our comprehensive interior design services that reflect your style and needs.",
      features: ["Space Planning", "Color Consultation", "Furniture Selection", "Lighting Design"]
    },
    {
      title: "Renovation & Remodeling",
      description: "Breathe new life into existing spaces with our expert renovation and remodeling services.",
      features: ["Kitchen Remodeling", "Bathroom Design", "Home Extensions", "Office Renovations"]
    }
  ];

  return (
    <section id="services" className="section services">
      <div className="container">
        <div className="services-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            We offer comprehensive design solutions tailored to your unique vision and requirements.
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <div className="icon-placeholder"></div>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
